'use client';

import * as React from 'react';
import { Switch as SwitchPrimitives } from '@base-ui/react/switch';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  Omit<SwitchPrimitives.Root.Props, 'ref'>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // Opacity only dims the unchecked (off/indeterminate-free) state: a
      // switch that's locked ON once set (no way to turn it back off, e.g.
      // TrimSavingsToggle) is checked AND disabled at the same time, and
      // halving an already-muted brand green read as "maybe off" rather
      // than "permanently on".
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background data-disabled:cursor-not-allowed data-disabled:data-unchecked:opacity-50 data-checked:bg-ds-brand-subtle data-unchecked:bg-input',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-checked:translate-x-4 data-unchecked:translate-x-0'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = 'Switch';

export { Switch };
